import type { StatusDotTone } from '@/components/atoms/StatusDot';
import type { CageListItem } from '@/domain/cages';

/** Active pens sort first, then inactive, then historical. */
export function statusPriority(status: CageListItem['status']): number {
    if (status === 'active') {
        return 0;
    }

    if (status === 'inactive') {
        return 1;
    }

    return 2;
}

export function statusDotTone(status: CageListItem['status']): StatusDotTone {
    if (status === 'active') {
        return 'success';
    }

    if (status === 'inactive') {
        return 'warning';
    }

    return 'neutral';
}

export function statusLabel(status: CageListItem['status']): string {
    if (status === 'active') {
        return 'common.labels.activeCages';
    }

    if (status === 'inactive') {
        return 'common.labels.inactiveCages';
    }

    return 'common.labels.historicalCages';
}
